var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.spellcheck && !_vm.loading)?_c(_vm.components.spellcheck,{tag:"component",staticClass:"ebx-spellcheck",attrs:{"query":_vm.query,"spellcheck":_vm.spellcheck}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }